module.exports = __webpack_public_path__ + "assets/img/round.6e93023f.png";